var React = require('react');

function SrpPassengers (props) {
    return React.createElement("svg",props,[React.createElement("circle",{"cx":"4.102","cy":"2.226","r":"2.226","key":0}),React.createElement("path",{"d":"M.461 9.984a.434.434 0 01-.429-.413v-.016c0-.127-.016-.207-.016-.254 0-.064-.016-.144-.016-.239 0-2.305 1.876-4.245 4.086-4.245 2.258 0 4.086 1.876 4.086 4.197 0 .064 0 .207-.016.302 0 .048-.016.143-.016.27a.447.447 0 01-.429.414l-7.25-.016z","key":1})]);
}

SrpPassengers.defaultProps = {"width":"8.172","height":"10","viewBox":"0 0 8.172 10"};

module.exports = SrpPassengers;

SrpPassengers.default = SrpPassengers;
